function withOpacity(color, opacity) {
  const r = parseInt(color.slice(1, 3), 16),
    g = parseInt(color.slice(3, 5), 16),
    b = parseInt(color.slice(5, 7), 16)

  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity + ')'
}

const Colors = {
  // DEFAULT COLORS
  White: '#ffffff',
  Black: '#000000',

  LightGrey: '#f1f1f1',
  CoolGrey: '#889298',
  Grey: '#122632',
  DarkGrey: '#4d5c65',
  Red: '#ec5a5a',
  PaleRed: '#e05151',
  Orange: '#FDA609',
  Yellow: '#ffb400',
  LightBlue: '#4ba7e8',
  GrassGreen: '#b0d121',
  PaleTeal: '#7eceaa',
  ErrorPageWhite: '#eef2f5',
  BackgroundMoreInfo: '#8f9ca5',

  // CORPORATE BRAND COLORS
  Brand: '#18ad84'
}
Colors['White012'] = withOpacity(Colors.White, 0.12)
Colors['White040'] = withOpacity(Colors.White, 0.4)
Colors['White060'] = withOpacity(Colors.White, 0.6)
Colors['White080'] = withOpacity(Colors.White, 0.8)
Colors['Black038'] = withOpacity(Colors.Black, 0.38)
Colors['Black06'] = withOpacity(Colors.Black, 0.6)
Colors['Black012'] = withOpacity(Colors.Black, 0.12)
Colors['Brand02'] = withOpacity(Colors.Brand, 0.2)
Colors['Brand05'] = withOpacity(Colors.Brand, 0.5)
Colors['GrassGreen02'] = withOpacity(Colors.GrassGreen, 0.2)
Colors['GrassGreen05'] = withOpacity(Colors.GrassGreen, 0.5)
Colors['Grey0'] = withOpacity(Colors.Grey, 0)
Colors['Grey008'] = withOpacity(Colors.Grey, 0.08)
Colors['Grey024'] = withOpacity(Colors.Grey, 0.24)
Colors['Grey08'] = withOpacity(Colors.Grey, 0.8)
Colors['PaleTeal015'] = withOpacity(Colors.PaleTeal, 0.15)

export default Colors

export {withOpacity}



// WEBPACK FOOTER //
// ./src/shared/assets/styles/colors.js